import React, { useState } from "react";

const EMPTY_ZAZNAM = { spz: "", datum: "", odkial: "", kam: "", ucel: "", km: "" };

function buildParams(obj) {
  return Object.entries(obj)
    .filter(([, v]) => v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
}

function KnihaJazd() {
  // filtre
  const [filterSpz,     setFilterSpz]     = useState("");
  const [filterDatumOd, setFilterDatumOd] = useState("");
  const [filterDatumDo, setFilterDatumDo] = useState("");
  const [filterUcel,    setFilterUcel]    = useState("");

  // dáta
  const [jazdy,       setJazdy]       = useState([]);
  const [editId,      setEditId]      = useState(null);  // id záznamu, ktorý sa práve edituje
  const [editData,    setEditData]    = useState({});
  const [novyZaznam,  setNovyZaznam]  = useState({ ...EMPTY_ZAZNAM });
  const [stav,        setStav]        = useState("");
  const [nacitane,    setNacitane]    = useState(false);

  // --- Načítať záznamy ---
  const nacitaj = async () => {
    setStav("Načítavam...");
    const params = buildParams({
      action:   "load",
      spz:      filterSpz,
      datum_od: filterDatumOd,
      datum_do: filterDatumDo,
      ucel:     filterUcel,
    });
    try {
      const r    = await fetch(`/php/jazdy_api.php?${params}`);
      const data = await r.json();
      setJazdy(data.jazdy || []);
      setNacitane(true);
      setStav("");
    } catch {
      setStav("Chyba pri načítaní");
    }
  };

  // --- Pridať nový záznam ---
  const pridaj = async () => {
    const spz = filterSpz || novyZaznam.spz;
    if (!spz || !novyZaznam.datum || !novyZaznam.odkial || !novyZaznam.kam) {
      setStav("Vyplňte ŠPZ, dátum, odkiaľ a kam");
      return;
    }
    setStav("Ukladám...");
    try {
      const r    = await fetch("/php/jazdy_api.php?action=add", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ ...novyZaznam, spz }),
      });
      const data = await r.json();
      if (data.success) {
        setJazdy(prev => [...prev, { ...novyZaznam, spz, id: data.id }]);
        setNovyZaznam({ ...EMPTY_ZAZNAM });
        setStav("Pridané");
      } else {
        setStav(data.message || "Chyba");
      }
    } catch {
      setStav("Chyba pri pridávaní");
    }
  };

  // --- Uložiť úpravy ---
  const ulozUpravu = async (id) => {
    setStav("Ukladám...");
    try {
      const r    = await fetch(`/php/jazdy_api.php?action=update&id=${id}`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(editData),
      });
      const data = await r.json();
      if (data.success) {
        setJazdy(prev => prev.map(j => j.id === id ? { ...j, ...editData } : j));
        setEditId(null);
        setStav("Uložené");
      } else {
        setStav(data.message || "Chyba");
      }
    } catch {
      setStav("Chyba pri ukladaní");
    }
  };

  // --- Zmazať záznam ---
  const zmazat = async (id) => {
    if (!window.confirm("Zmazať tento záznam?")) return;
    setStav("Mažem...");
    try {
      const r    = await fetch(`/php/jazdy_api.php?action=delete&id=${id}`, { method: "POST" });
      const data = await r.json();
      if (data.success) {
        setJazdy(prev => prev.filter(j => j.id !== id));
        setStav("Zmazané");
      } else {
        setStav(data.message || "Chyba");
      }
    } catch {
      setStav("Chyba pri mazaní");
    }
  };

  // --- Export do Excelu (CSV) ---
  const exportCsv = () => {
    const params = buildParams({
      action:   "export",
      spz:      filterSpz,
      datum_od: filterDatumOd,
      datum_do: filterDatumDo,
      ucel:     filterUcel,
    });
    window.location.href = `/php/jazdy_api.php?${params}`;
  };

  const celkoveKm = jazdy.reduce((s, j) => s + (parseFloat(j.km) || 0), 0);

  const inp = { style: { width: "100%", boxSizing: "border-box", padding: "2px 4px" } };

  return (
    <div style={{ maxWidth: 900, margin: "2em auto", padding: 20, fontFamily: "sans-serif" }}>
      <h2 style={{ marginBottom: 16 }}>Kniha jázd</h2>

      {/* --- Filtre --- */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14, alignItems: "flex-end" }}>
        <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>
          ŠPZ
          <input value={filterSpz} onChange={e => setFilterSpz(e.target.value.toUpperCase())}
            placeholder="napr. BL123AB" style={{ width: 110, padding: "3px 6px" }} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>
          Dátum od
          <input type="date" value={filterDatumOd} onChange={e => setFilterDatumOd(e.target.value)}
            style={{ padding: "3px 6px" }} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>
          Dátum do
          <input type="date" value={filterDatumDo} onChange={e => setFilterDatumDo(e.target.value)}
            style={{ padding: "3px 6px" }} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>
          Účel (obsahuje)
          <input value={filterUcel} onChange={e => setFilterUcel(e.target.value)}
            placeholder="napr. služobná" style={{ width: 160, padding: "3px 6px" }} />
        </label>
        <button onClick={nacitaj} style={{ padding: "5px 16px", alignSelf: "flex-end" }}>Načítať</button>
        <button onClick={exportCsv} disabled={!nacitane}
          style={{ padding: "5px 16px", alignSelf: "flex-end", background: "#217346", color: "#fff", border: "none", borderRadius: 4, cursor: nacitane ? "pointer" : "not-allowed" }}>
          Export Excel (CSV)
        </button>
      </div>

      {/* --- Tabuľka --- */}
      {nacitane && (
        <>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th style={th}>ŠPZ</th>
                <th style={th}>Dátum</th>
                <th style={th}>Odkiaľ</th>
                <th style={th}>Kam</th>
                <th style={th}>Účel</th>
                <th style={{ ...th, width: 70 }}>Km</th>
                <th style={{ ...th, width: 90 }}></th>
              </tr>
            </thead>
            <tbody>
              {jazdy.map(j => (
                <tr key={j.id} style={{ borderBottom: "1px solid #ddd" }}>
                  {editId === j.id ? (
                    <>
                      <td style={td}><input value={editData.spz}    onChange={e => setEditData({ ...editData, spz: e.target.value })}    {...inp} /></td>
                      <td style={td}><input type="date" value={editData.datum}  onChange={e => setEditData({ ...editData, datum: e.target.value })}  {...inp} /></td>
                      <td style={td}><input value={editData.odkial} onChange={e => setEditData({ ...editData, odkial: e.target.value })} {...inp} /></td>
                      <td style={td}><input value={editData.kam}    onChange={e => setEditData({ ...editData, kam: e.target.value })}    {...inp} /></td>
                      <td style={td}><input value={editData.ucel}   onChange={e => setEditData({ ...editData, ucel: e.target.value })}   {...inp} /></td>
                      <td style={td}><input type="number" value={editData.km} onChange={e => setEditData({ ...editData, km: e.target.value })} {...inp} /></td>
                      <td style={td}>
                        <button onClick={() => ulozUpravu(j.id)} style={btnSave}>Uložiť</button>
                        <button onClick={() => setEditId(null)}   style={btnCancel}>Zrušiť</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td style={td}>{j.spz}</td>
                      <td style={td}>{j.datum}</td>
                      <td style={td}>{j.odkial}</td>
                      <td style={td}>{j.kam}</td>
                      <td style={td}>{j.ucel}</td>
                      <td style={{ ...td, textAlign: "right" }}>{j.km}</td>
                      <td style={td}>
                        <button onClick={() => { setEditId(j.id); setEditData({ spz: j.spz, datum: j.datum, odkial: j.odkial, kam: j.kam, ucel: j.ucel, km: j.km }); }}
                          style={btnEdit}>Upraviť</button>
                        <button onClick={() => zmazat(j.id)} style={btnDel}>Zmazať</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}

              {/* --- Nový záznam --- */}
              <tr style={{ background: "#f9f9f9" }}>
                <td style={td}><input value={novyZaznam.spz || filterSpz}
                  onChange={e => setNovyZaznam({ ...novyZaznam, spz: e.target.value })}
                  placeholder={filterSpz || "ŠPZ"} {...inp} /></td>
                <td style={td}><input type="date" value={novyZaznam.datum}
                  onChange={e => setNovyZaznam({ ...novyZaznam, datum: e.target.value })} {...inp} /></td>
                <td style={td}><input value={novyZaznam.odkial}
                  onChange={e => setNovyZaznam({ ...novyZaznam, odkial: e.target.value })}
                  placeholder="Odkiaľ" {...inp} /></td>
                <td style={td}><input value={novyZaznam.kam}
                  onChange={e => setNovyZaznam({ ...novyZaznam, kam: e.target.value })}
                  placeholder="Kam" {...inp} /></td>
                <td style={td}><input value={novyZaznam.ucel}
                  onChange={e => setNovyZaznam({ ...novyZaznam, ucel: e.target.value })}
                  placeholder="Účel" {...inp} /></td>
                <td style={td}><input type="number" value={novyZaznam.km}
                  onChange={e => setNovyZaznam({ ...novyZaznam, km: e.target.value })}
                  placeholder="0" {...inp} /></td>
                <td style={td}>
                  <button onClick={pridaj} style={{ ...btnSave, width: "100%" }}>+ Pridať</button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} style={{ ...td, textAlign: "right", fontWeight: "bold" }}>Celkom km:</td>
                <td style={{ ...td, textAlign: "right", fontWeight: "bold" }}>{celkoveKm.toFixed(1)}</td>
                <td style={td}></td>
              </tr>
            </tfoot>
          </table>
        </>
      )}

      {stav && <div style={{ marginTop: 10, color: stav.startsWith("Chyba") ? "red" : "#333" }}>{stav}</div>}
    </div>
  );
}

const th = { padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #ccc" };
const td = { padding: "4px 6px", verticalAlign: "middle" };
const btnEdit   = { fontSize: 11, marginRight: 4, padding: "2px 6px", cursor: "pointer" };
const btnDel    = { fontSize: 11, padding: "2px 6px", background: "#c0392b", color: "#fff", border: "none", borderRadius: 3, cursor: "pointer" };
const btnSave   = { fontSize: 11, marginRight: 4, padding: "2px 6px", background: "#27ae60", color: "#fff", border: "none", borderRadius: 3, cursor: "pointer" };
const btnCancel = { fontSize: 11, padding: "2px 6px", cursor: "pointer" };

export default KnihaJazd;
